
import { Component, Vue, Watch } from "vue-property-decorator";
import html2Pdf from "../../lib/html2pdf";
import request from "@/lib/request/request";
import { CompanyConfig } from "@/lib/common/acm";
import { FingerCheckResult } from "@/lib/model/exam/result";
import { AllOptionText } from "@/lib/model/workerbuilder/exam-v3";
import Login from "@/views/paper/paper-result-report/login.vue"; //提取码登录
import { Report } from "@/lib/model/exam/candidate";

import {
  Answer,
  Candidate,
  CandidateResult,
  MiddleInfo,
  Param,
  CvData,
  ImgInfo,
  R,
  PP
} from "@/lib/model/exam/result";

enum bodyStatus {
  "未按要求拍摄",
  "无纹身疤痕",
  "检测到疤痕",
  "检测到纹身",
  "检测到疤痕和纹身"
}
enum ydgdBodyStatus {
  "未按要求拍摄",
  "无残缺残疾",
  "不明显残疾",
  "明显残疾"
}
enum enumFinger {
  "未按要求拍摄" = 0,
  "通过" = 1,
  "有异常" = 2,
  "考察项未配置" = 255
}

export class EmotionData {
  emotionType = "";
  imgUrl = "";
}

@Component({ components: { Login } })
export default class PaperResult extends Vue {
  $refs!: {
    echartsR: HTMLCanvasElement;
    echartTop: HTMLCanvasElement;
    result: HTMLFormElement;
    PCvideo: HTMLElement[];
  };
  down = false;
  //饼图用色
  colorList = [
    "#4CDE99",
    "#FDC151",
    "#33DFE4",
    "#8851FD",
    "#33B1FF",
    "#FF9245",
    "#FD5151",
    "#BDFD51",
    "#516AFD",
    "#B999D4",
    "#51FD84",
    "#FD51B8",
    "#FDFB51",
    "#51FDC5",
    "#E551FD"
  ];
  //成绩
  infoList: any[] = [];
  //AI维度
  AIList: any[] = [];
  scoreTotal = 0; //总分
  scoreTotalAll = 0; //满分
  all = new CandidateResult();
  dataReady = false; //数据加载完成
  isPc = false; //是否pc访问
  bgList: any[] = []; //背调信息
  pcList: any[] = []; //身份核验信息
  emotionDataList: EmotionData[] = []; //神态截图
  psychiatricExaminationAi = 0;
  psychiatricExaminationHr = 0;
  cvData: CvData = new CvData(); //工单数据
  cvDataOver = true; //是否完成填写
  eyePass = false; //色盲 色盲检测结果
  eyePassSF = false; //色盲 顺丰色盲检测结果
  mindQuestion: any = []; //心理题
  mLimit = 3; //展示数量限制
  mindQuestionLeft: any = [];
  mindQuestionRight: any = [];
  mindQuestion1: any = []; //ydgd 心理题用 三个维度
  mindQuestion2: any = [];
  mindQuestion3: any = [];
  mindScore: any = {};
  downing = false;
  showTT = false;
  candidate = new Candidate(); //候选人信息 主表
  candidateResult = new CandidateResult(); //候选人信息 所有表
  connectCode = "";
  middleInfo = new MiddleInfo();
  markeTime = "";
  fskBodyInfo = new Answer(); //形体检查
  ydgdBodyInfo = new Answer(); //手臂检查
  topData: any = {}; //核心关注项
  realHeadPhotoUrl = "";
  showMIndQuestion = false; //ydgd 心理题目展示
  showBigImg = false;
  bigImgUrl = "";
  isWorker = false;
  isYD = false;
  mindQAList: PP[] = []; //普工心理题
  newPsy: any = ""; // 新版普工心理测评20231109
  // resLogo = "";
  privacy =
    "以上资料保证完整、真实并愿意接受集团背景。本人承诺：如有不实或隐瞒（含学历、经历、集团工作亲属信息、既往病史及目前健康状况等），本人愿接受公司解除劳动合同处理。";

  get isNewAi() {
    return (
      ([
        80976,
        82070,
        80978,
        559,
        81022,
        81023,
        81025,
        81027,
        81041,
        81044,
        81043,
        81042,
        81040,
        81039,
        89792,
        81177,
        81175,
        81191,
        81190,
        81189,
        81188
      ].includes(Number(this.all.exam.companyId)) ||
        this.all.exam.companyId >= 91353) &&
      ![91415, 194].includes(Number(this.all.exam.companyId))
    );
  }

  get resLogo() {
    const t = Number(this.candidate.auditStatus); //结果logo
    return require("../../assets/exam/" +
      (t === 1 ? "r1" : t === 2 ? "r2" : t === 3 ? "r3" : "r00") +
      ".png");
  }
  get styleVar() {
    return {
      "--red": "red"
    };
  }
  get getMindQuestionLeft() {
    return JSON.parse(JSON.stringify(this.mindQuestionLeft)).splice(
      0,
      this.mLimit
    );
  }
  get getMindQuestionRight() {
    return JSON.parse(JSON.stringify(this.mindQuestionRight)).splice(
      0,
      this.mLimit
    );
  }
  get videoF() {
    return this.fskBodyInfo?.bodyCheckAnswer?.imgList?.[3]?.imgUrl || "";
  }
  //计算返回按钮位置
  get setFixed() {
    const full: HTMLElement = this.$refs["full"] as HTMLElement;
    const w = Number(full.clientWidth) / 2 - 48 - 420 - 16;
    return w + "px";
  }
  //AI评估中
  get isAIing() {
    return this.candidate.aiProcessStatus !== 3;
  }
  get isHrChange() {
    return this.candidate.auditTimeAi !== this.candidate.auditTime;
  }
  //是否展示工单
  get showGD() {
    return this.candidate.needCv === 1;
  }

  //富士康 通用demo
  get isFSKDemo() {
    return this.all.exam.examType === "test";
  }

  //手指检测109
  get finger() {
    return (
      this.all?.questionAnswerMap?.[109]?.[0]?.answer?.fingerCheckResult ||
      new FingerCheckResult()
    );
  }

  //打气球游戏数据
  get gameQi() {
    const t = this.all?.questionAnswerMap?.[107].find((d: any) => {
      return d?.answer?.gameTestAnswerResult?.gameTestType === 1;
    });
    return (
      t?.answer?.gameTestAnswerResult ?? new Answer()?.gameTestAnswerResult
    );
  }
  //西蒙斯游戏数据
  get gameXi() {
    const t = this.all?.questionAnswerMap?.[107].find((d: any) => {
      return d?.answer?.gameTestAnswerResult?.gameTestType === 2;
    });
    return (
      t?.answer?.gameTestAnswerResult ?? new Answer()?.gameTestAnswerResult
    );
  }

  created() {
    document.title = document.location.origin.includes("mianshi.nrpla")
      ? "牛人星球"
      : "海纳AI面试";
  }
  tid = "";
  // 缓存提取码对应的面试id
  reportCertiCodeCacheExamId = 0;
  // 是否需要提取码
  async needPassword(retryCount = 0): Promise<boolean | undefined> {
    try {
      const res = await Report.getInfo({
        connectCode: this.connectCode,
        tid: this.$route.query.tid as string
      });
      this.reportCertiCodeCacheExamId = res.reportCertiCodeCacheExamId;
      return res.needReportCertiCode;
    } catch (e) {
      console.error(e);
      // 可以根据重试次数决定是否再次调用
      if (retryCount < 3) {
        // 假设最多重试3次
        return this.needPassword(retryCount + 1);
      } else {
        // 达到最大重试次数后
        this.$message.error("网络不佳，请稍后重试吧");
      }
    }
  }

  showLogin = false;
  login() {
    this.showLogin = false;
    this.loadPage();
  }

  async checkPwd() {
    const needPwd = await this.needPassword(); //此处不封try catch，网络不通就需要停在这里
    if (needPwd) {
      //先判缓存的提取码是否正确
      const pass = await (this.$refs as any).login.checkLocalstroage();
      //不正确则展示提取码页面
      if (!pass) {
        this.showLogin = true;
      }
      return pass;
    }
    return true; //不需要提取码
  }

  async mounted() {
    this.connectCode = this.$route.query.connectCode as string;
    this.isPc = !this.isMobile();
    //是否需要输入提取码
    const pass = await this.checkPwd();
    if (!pass) return;

    this.loadPage();
  }
  async loadPage() {
    // const mainDom = document.getElementsByClassName(
    //   "el-main"
    // )[0] as HTMLElement;
    // mainDom.style.padding = "0";
    //鉴权
    if (this.$route.query.tid) {
      this.tid = String(this.$route.query.tid);
    }
    //判考试类型
    const res = await CandidateResult.getCid(
      Number(this.$route.query?.connectCode),
      this.tid
    );
    this.isWorker = ["test", "aiworker"].includes(res.examType);
    this.isYD = [91415, 194].includes(Number(res.companyId));

    this.open();
  }
  optionAll: any = {}; //全量配置
  //富士康 工单 已废弃 又活了
  async getWorkInfo() {
    await CandidateResult.getFSK({ connectCode: this.connectCode }).then(
      (res: any) => {
        if (res?.data?.code === 0) {
          //精神状态
          this.emotionDataList = res?.data?.data?.emotionData || [];
          this.psychiatricExaminationAi =
            res?.data?.data?.psychiatricExaminationAi;
          this.psychiatricExaminationHr =
            res?.data?.data?.psychiatricExaminationHr;
          //工单
          this.cvData = res?.data?.data?.cvData ?? new CvData(); //工单
          this.cvDataOver = res?.data?.data?.cvDataAfterSubmit ?? true; //是否完成工单填写
          this.optionAll = res?.data?.data; //全量配置

          // this.realHeadPhotoUrl = res?.data?.data?.passportPhotoUrl ?? ""; //证件照照片
          //表格空字段转 -
          for (const key in this.cvData) {
            if (this.cvData[key].constructor === Array) {
              this.cvData[key].forEach((row: any) => {
                for (const k in row) {
                  row[k] = row[k] === "" ? "-" : row[k];
                }
              });
            }
          }
          this.markeTime = res?.data?.data?.cvDataTime; //签字时间
          // this.gameQiFSK = res?.data?.data?.gameResultAnswer; //游戏结果
        }
      }
    );
  }

  //入口
  async open() {
    //确保Ec容器渲染完成
    this.$nextTick(() => {
      //主表
      Candidate.get({ connectCode: this.connectCode, tid: this.tid })
        .then(async res => {
          res.paramList = res.paramList.filter(d => {
            return d.isShow === 1;
          });
          this.candidate = res;
          // if (this.candidate?.bgCheckResult?.product?.productId !== 0) {
          //购买背调
          this.getBG();
          // }
          this.realHeadPhotoUrl = res?.photoUrl || ""; //证件照照片

          if (this.candidate.needCv === 1) {
            await this.getWorkInfo(); //工单信息
          }

          //所有表
          return CandidateResult.get({
            connectCode: this.connectCode,
            tid: this.tid
          });
        })
        .then(r => {
          this.all = r;
          this.topData = r?.headerDataList; //核心关注项
          this.getFSKBody();
          this.sortInfo(); //个人信息 排序
          this.showColorRes(); //色盲结果
          this.getMindQuestion(); //心理题型
          this.getPC(); //身份核验
          // this.setScoreEc();
          this.$nextTick(() => {
            this.listenVideo(); //视频监听
            this.dataReady = true;
          });
        });
    });
  }

  //个人信息 根据文字长度整理
  sortInfo() {
    const arrL: any[] = []; //长选项
    const arrS: any[] = []; //短选项
    this.candidate?.paramList.forEach((d: any) => {
      // if (!["姓名", "手机"].includes(d.name)) return; //富士康 固定展示项
      if (d?.name.length > 21 || d?.cascadeValue.length > 18) {
        d.long = true;
        arrL.push(d);
      } else {
        arrS.push(d);
      }
    });
    // this.candidate.paramList = [...arrS, ...arrL];
  }
  //处理色盲测试结果
  showColorRes() {
    // if (this.all.exam.colorTest === 1) {
    this.all.answerList.forEach((d: Answer) => {
      if (d.type === 102) {
        const t = new Param();
        t.name = "色盲检测";
        t.cascadeValue = d.testResult === 1 ? "通过" : "不通过";
        this.eyePass = d.testResult === 1;
        // this.candidate.paramList.push(t);
      }
    });
    // }
  }
  //心理题 组装
  getMindQuestion() {
    this.mindQuestion = [];
    let aData: any = {};
    this.all.answerList.forEach((d: any) => {
      if (d.type === 105) {
        aData = d;
      }
      if (d.type === 106) {
        this.newPsy = d;
      }
    });
    console.log(this.newPsy);
    if (!aData?.psychologicalQuestionAnswerResult) return;
    if (this.isYD) {
      //友达光电版
      aData?.psychologicalQuestionAnswerResult?.psychologicalAnswerList.forEach(
        (d: any) => {
          this.mindQuestion.push({
            desc: d.questionDesc,
            level: d.level,
            answer: d.answerDesc || "未作答"
          });
        }
      );
      // this.mindScore = aData?.psychologicalQuestionAnswerResult || new R(); //心理题 得分
      // this.mindQuestionLeft = [...this.mindQuestion].slice(0, 16); //作答展示
      // this.mindQuestionRight = [...this.mindQuestion].slice(16);
      this.mindQuestion1 = [...this.mindQuestion].slice(0, 10); //ydgd 心理题 10道 * 3个维度
      this.mindQuestion2 = [...this.mindQuestion].slice(10, 20);
      this.mindQuestion3 = [...this.mindQuestion].slice(20, 30);
    } else {
      //普工心理题 类型list 最新
      this.mindQAList =
        aData?.psychologicalQuestionAnswerResult?.psycDimensionList;
    }
  }
  //背调结果
  getBG() {
    const levelToRisk = {
      // 0:旧数据 1:低等级 2:中等级 3:高登记 4:异常等级
      0: "旧数据",
      1: "存在低风险",
      2: "存在中风险",
      3: "存在高风险",
      4: "存在异常风险"
    };
    const socialStatus = new AllOptionText().socialStatus;
    const b = this.candidate.bgCheckResult;
    console.log("all", this.candidate);
    const {
      socialInfoStatus,
      socialInfoErrorLevel,
      financialRiskStatus,
      financialRiskErrorLevel
    } = this.candidate.bgCheckResult;
    if (![0, 255].includes(b.socialInfoStatus)) {
      this.bgList.push({
        title: "负面社会安全记录查询",
        text:
          socialInfoStatus === 3 &&
          socialInfoErrorLevel &&
          socialInfoErrorLevel > 0
            ? levelToRisk[socialInfoErrorLevel]
            : socialStatus[b.socialInfoStatus].text,
        status: socialStatus[b.socialInfoStatus].status
      });
    }
    if (![0, 255].includes(b.financialRiskStatus)) {
      this.bgList.push({
        title: "金融风险记录查询",
        text:
          financialRiskStatus === 3 &&
          financialRiskErrorLevel &&
          financialRiskErrorLevel > 0
            ? levelToRisk[financialRiskErrorLevel]
            : socialStatus[b.financialRiskStatus].text,
        status: socialStatus[b.financialRiskStatus].status
      });
    }
  }
  //身份核验相关
  getPC() {
    this.pcList = [];
    const a = this.all?.livenessRecognitionResult;
    if (a._isAssignedFlag) {
      this.pcList.push({
        title: "身份认证",
        text: !a.isTested ? "未完成提交" : a.isPass === 1 ? "通过" : "未通过",
        type: a.isPass === 1 ? 2 : 1
      });
    }
    const b = this.candidate?.replaceCheckResult;
    if (b._isAssignedFlag) {
      this.pcList.push({
        title: "换人检测",
        text:
          b.result === 0 ? "未完成提交" : b.result === 2 ? "通过" : "未通过",
        type: b.result === 2 ? 2 : 1
      });
    }
    const c = this.candidate.bgCheckResult.identityInfoStatus;
    if (![0, 255].includes(c)) {
      this.pcList.push({
        title: "手机号实名认证",
        text: c === 102 ? "未授权" : c === 2 ? "通过" : "未通过",
        type: c
      });
    }
  }

  //下载pdf
  downPDF() {
    //展开折叠项  隐藏一些操作按钮
    this.downing = true;
    const ml = this.mLimit + 0;
    const downStatus = this.down;
    const downloadBtn: HTMLElement = document.getElementById(
      "download"
    ) as HTMLElement;
    const downBtn1: HTMLElement = document.getElementById(
      "downBtn1"
    ) as HTMLElement;
    const downBtn2: HTMLElement = document.getElementById(
      "downBtn2"
    ) as HTMLElement;
    const resultBox: HTMLElement = document.getElementById(
      "mainBox"
    ) as HTMLElement;
    if (downloadBtn) downloadBtn.style.visibility = "hidden";
    if (downBtn1) {
      downBtn1.style.visibility = "hidden";
      downBtn1.style.height = "0";
    }
    if (downBtn2) {
      downBtn2.style.visibility = "hidden";
      downBtn2.style.height = "0";
    }
    this.down = true;
    // this.$forceUpdate();
    this.$nextTick(() => {
      this.mLimit = 8;
      // this.$forceUpdate();
      this.$nextTick(() => {
        setTimeout(() => {
          html2Pdf.downloadPDF(
            resultBox,
            "面试报告-" + this.candidate.showName
          );
          setTimeout(() => {
            if (downloadBtn) downloadBtn.style.visibility = "visible";
            if (downBtn1) {
              downBtn1.style.visibility = "visible";
              downBtn1.style.height = "40px";
            }
            if (downBtn2) {
              downBtn2.style.visibility = "visible";
              downBtn2.style.height = "40px";
            }
            this.down = downStatus;
            this.mLimit = ml;
            this.downing = false;
            //
          }, 1);

          //
        }, 1);
      });
    });
  }
  //头像占位
  defImg(event: any) {
    this.candidate.photoUrl = "";
    const img = event.srcElement;
    // img.src = require("../../assets/head-logo-long.png");
    img.onerror = null; //防止闪图
  }

  //asr内容
  asrText(list: any) {
    if (list.length === 0) {
      return "未识别出内容";
    }
    let text = "";
    list.forEach((d: any) => {
      text += d.txt;
    });
    return text;
  }
  //
  downMind() {
    this.mLimit = this.mLimit === 3 ? 8 : 3;
    if (this.mLimit === 3) {
      (this.$refs["anchor10"] as HTMLElement).scrollIntoView({
        behavior: "auto",
        block: "start"
      });
    }
  }
  downGD() {
    this.down = !this.down;
    if (!this.down) {
      (this.$refs["anchorGD"] as HTMLElement).scrollIntoView({
        behavior: "auto",
        block: "start"
      });
    }
  }

  // 滑动 关注项是否已出可视区域
  handleScroll() {
    const rect = (this.$refs[
      "anchorGD"
    ] as HTMLElement)?.getBoundingClientRect();
    if (rect?.top < 0) {
      this.showTT = true;
    } else {
      this.showTT = false;
    }
  }
  //自动暂停其他视频
  listenVideo() {
    //滚动监听
    this.$nextTick(() => {
      window.addEventListener("scroll", () => {
        this.handleScroll();
      });
    });
    // this.handleScroll();
    const v: any = this.$refs.PCvideo;
    if (!v) return;
    v.forEach((video: any) => {
      video.addEventListener("play", (d: any) => {
        v.forEach((item: any) => {
          if (d.currentTarget.id !== item.id) {
            item.pause();
          }
        });
      });
    });
  }
  filterQuestion(i: number) {
    return this.all.questionList.filter(d => {
      // return i === 6 ? d.type === i : d.type !== 6;
      return i === d.type;
    });
  }
  //富士康 形体数据
  getFSKBody() {
    //形体检查
    const t = this.all.questionList.findIndex(d => {
      return d.type === 104;
    });
    this.fskBodyInfo = this.all.answerList[t] ?? new Answer();
    //手臂检查 友达光电
    const t2 = this.all.questionList.findIndex(d => {
      return d.type === 108;
    });

    this.ydgdBodyInfo = this.all.answerList[t2] ?? new Answer();
  }
  getLogo(d: any) {
    if (!d.values?.length) return 1;

    const errContent = d.values.find((t: any) => t.type !== 0);

    if (errContent) return 1;

    const op = new AllOptionText().op;
    const resList = op[d.key]?.resList || [];

    for (let i = 0; i < (d.values || []).length; i++) {
      const t: any = d.values[i];

      const res = resList.find(
        (r: any) => r.text === t.content || r.title === t.content
      );

      if (res) return res.status;
    }

    return 0;
  }
  //形体结果
  bodyEnum(d = new ImgInfo()) {
    let t = bodyStatus[d?.result];
    if (d?.imgUrl === "1") {
      t = d?.result === 1 ? "通过" : "未通过"; //人脸识别
    }
    t = this.isAIing ? "AI评估中" : t;
    // const c = [0, 1].includes(d?.result) ? "#8590A6FF" : "#FF5055FF";
    const color =
      d?.result === 0 ? "#8590A6FF" : d?.result === 1 ? "#27ba9c" : "#e64340ff";
    return `<span style="color:${color};margin-left:12px;font-weight: 600;">${t}</span>`;
  }
  //手臂结果
  ydgdBodyEnum(i: number) {
    const d1 = this.ydgdBodyInfo.bodyCheckAnswer?.imgList?.[i]?.result;
    const d2 = this.ydgdBodyInfo.bodyCheckAnswer?.imgList?.[i + 1]?.result;
    if (d1 === undefined || d2 === undefined) return;
    //取最坏的结果
    let result = Math.max(d1, d2);
    //有一个未拍摄则算未拍摄（0）
    result = [d1, d2].includes(0) ? 0 : result;
    let t = ydgdBodyStatus[result];
    t = this.isAIing ? "AI评估中" : t;
    const color =
      result === 0 ? "#8590A6FF" : result === 1 ? "#27ba9c" : "#e64340ff";
    return `<span style="color:${color};margin-left:12px;font-weight: 600;">${t}</span>`;
  }
  //锚点
  toAnchor(an: any, index: any) {
    const t = an + index;
    const dom = an === "anchor3" ? this.$refs[t][0] : this.$refs[t]; //节点
    if (!dom) return;
    this.down = t === "anchor23" ? true : this.down;
    this.$nextTick(() => {
      setTimeout(() => {
        (dom as HTMLElement).scrollIntoView({
          behavior: "smooth",
          block: "start"
        });
      }, 1);
    });
  }
  toTop() {
    const t: HTMLElement = document.getElementById("mainBox") as HTMLElement;
    t.scrollIntoView({
      behavior: "smooth",
      block: "start"
    });
  }
  //设备查询
  isMobile(): boolean {
    const isIos = /(iPhone|iPad|iPod|iOS)/i.test(navigator.userAgent);
    const isAndroid = /(Android)/i.test(navigator.userAgent);
    return isIos || isAndroid;
  }

  //打开简历 新版字段
  async showAttachment(url: string) {
    const androidPdf =
      /(Android)/i.test(navigator.userAgent) && url?.slice(-3) === "pdf";
    if (
      url?.slice(-4) === "docx" ||
      url?.slice(-3) === "doc" ||
      url?.slice(-4) === "pptx" ||
      androidPdf
    ) {
      await this.sendRequest("/aiExam/common/previewDocUrl", { url }).then(
        (res: any) => {
          url = res?.data?.url;
        }
      );
    }
    const h = window.outerHeight;
    const w = Math.max((window.innerWidth - 840) / 2, 540);
    const left =
      (window.screenX || window.screenLeft || 0) + window.innerWidth - w;
    if (this.isMobile()) {
      document.location.href = url;
    } else {
      window.open(
        url,
        "_blank",
        `height=${h}, width=${w}, top=0, left=${left}, toolbar=no, menubar=no, scrollbars=no,location=no, resizable=yes, directories=yes, status=no`
      );
    }
  }

  fingerResText(i: number) {
    return enumFinger[i];
  }

  //查看大图
  openImg(url: string) {
    this.bigImgUrl = url;
    this.showBigImg = true;
  }

  //请求接口统一处理
  sendRequest(url: any, params = {}, method = "post") {
    return new Promise(function(resolve, reject) {
      request[method](url, params).then((resp: { data: any }) => {
        if (resp.data.code === 0) {
          resolve(resp.data);
        } else {
          reject(resp.data.message);
        }
      });
    }).catch(e => {
      console.log(e);
    });
  }
}
